import { CircleAlert, CircleCheck, Info, TriangleAlert } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

const tones = {
  info: { box: "bg-info-soft text-info-ink", tile: "bg-info", Icon: Info },
  success: { box: "bg-success-soft text-success-ink", tile: "bg-success", Icon: CircleCheck },
  warning: { box: "bg-warning-soft text-warning-ink", tile: "bg-warning", Icon: TriangleAlert },
  danger: { box: "bg-danger-soft text-danger-ink", tile: "bg-danger", Icon: CircleAlert },
};

/** Tinted banner for notices, errors and hints. */
export function Callout({
  tone = "info",
  title,
  action,
  children,
  className,
}: {
  tone?: keyof typeof tones;
  title?: ReactNode;
  action?: ReactNode;
  children?: ReactNode;
  className?: string;
}) {
  const { box, tile, Icon } = tones[tone];
  return (
    <div role={tone === "danger" ? "alert" : "status"} className={cn("flex items-start gap-3 rounded-xl px-4 py-3 text-[13px]", box, className)}>
      <span className={cn("mt-0.5 inline-flex size-6 shrink-0 items-center justify-center rounded-md text-white", tile)}>
        <Icon className="size-3.5" />
      </span>
      <div className="min-w-0 flex-1 self-center">
        {title && <p className="font-medium">{title}</p>}
        {children && <div className={cn(!!title && "opacity-90")}>{children}</div>}
      </div>
      {action && <div className="shrink-0 self-center">{action}</div>}
    </div>
  );
}
